import React from 'react'
import styled from 'styled-components'
import Input from 'components/input/Input'
// import { Section } from './AutoFormStyled'
import { StopOnInput } from './StopOnInput'
import Currencies from 'functions/currency/getCurrencySymbol'

interface StopOnProps {
  stopOnProfit: string
  setstopOnProfit: any
  stopOnLoss: string
  setstopOnLoss: any
  currency: string
}
export default function StopOn({
  stopOnProfit,
  setstopOnProfit,
  stopOnLoss,
  setstopOnLoss,
  currency
}: StopOnProps) {
  return (
    <Wrapper>
      <StopArticle
        title='STOP ON PROFIT'
        stopOn={stopOnProfit}
        setstopOn={setstopOnProfit}
        currency={currency}
      />
      <StopArticle
        title='STOP ON LOSS'
        stopOn={stopOnLoss}
        setstopOn={setstopOnLoss}
        currency={currency}
      />
    </Wrapper>
  )
}
export const Wrapper = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: -2px;
`

interface StopArticleProps {
  title: string
  stopOn: string
  setstopOn: any
  currency: string
}

const StopArticle = ({
  title,
  stopOn,
  setstopOn,
  currency
}: StopArticleProps) => {
  return (
    <article style={{ width: '149px' }}>
      <h6>{title}</h6>
      <StopOnInput>
        <Input
          number={stopOn}
          setnumber={(e: any) => setstopOn(e)}
          setinputStake={(e: any) => setstopOn(e)}
          type='numbersAndDot'
          min='0.00'
          max='100000000'
          maxLength={8}
          toFix={2}
          width='100%'
          height='24px'
          size='12px'
          textcenter='center'
          margin='14px 25px'
          textOverflow='ellipsis'
          overflow='hidden'
        />
        {Currencies[currency]}
      </StopOnInput>
    </article>
  )
}

// {
//   /* <Section width='150px' border> */
// }
// {
//   /* </Section> */
// }
